export const PRESENTATIONAL_COLUMNS_RESTRICTIONS_GET_DATA_REQUEST = 'PRESENTATIONAL_COLUMNS_RESTRICTIONS_GET_DATA_REQUEST';
export const PRESENTATIONAL_COLUMNS_RESTRICTIONS_GET_DATA_ERROR = 'PRESENTATIONAL_COLUMNS_RESTRICTIONS_GET_DATA_ERROR';
export const PRESENTATIONAL_COLUMNS_RESTRICTIONS_GET_DATA_SUCCESS = 'PRESENTATIONAL_COLUMNS_RESTRICTIONS_GET_DATA_SUCCESS';

export const PRESENTATIONAL_COLUMNS_RESTRICTIONS_SET_RESTRICTION_REQUEST = 'PRESENTATIONAL_COLUMNS_RESTRICTIONS_SET_RESTRICTION_REQUEST';

export const PRESENTATIONAL_COLUMNS_RESTRICTIONS_UPDATE_SUCCESS = 'PRESENTATIONAL_COLUMNS_RESTRICTIONS_UPDATE_SUCCESS';
export const PRESENTATIONAL_COLUMNS_RESTRICTIONS_UPDATE_ERROR = 'PRESENTATIONAL_COLUMNS_RESTRICTIONS_UPDATE_ERROR';
